import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { ChartsWrapper, useViewportWidth, DoughnutChart, BarChart, SectionHeader, Section } from '@paddl/storybook';
import _ from 'lodash';
import { useResource } from '../../hooks/useResource';
export const ProfileCharts_V2 = _ref => {
  let {
    profileId
  } = _ref;
  const width = useViewportWidth();
  const isViewPortSmall = width === 'xs' || width === 'sm';
  const {
    data: skillCountsData
  } = useResource("".concat(process.env.AT_WORK_API, "/v2/profile/").concat(profileId, "/stats/skill-counts"));
  const top5Skills = _.orderBy((skillCountsData === null || skillCountsData === void 0 ? void 0 : skillCountsData.skillCounts) || [], 'count', 'desc').slice(0, 5);
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(SectionHeader, null, "Experience"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8
  }, /*#__PURE__*/React.createElement(ChartsWrapper, {
    headLine: "Top Skills",
    tagLine: "By number of Activities",
    tooltipText: "Shows the top 5 skills by the number of Activities they have been tagged in",
    shouldShowTooltip: !isViewPortSmall,
    chartBackgroundColor: "purple",
    chartPadding: "small"
  }, /*#__PURE__*/React.createElement(BarChart, {
    "data-test-id": "bar-chart",
    labels: top5Skills.map(_ref2 => {
      let {
        skillName
      } = _ref2;
      return skillName;
    }),
    data: top5Skills.map(_ref3 => {
      let {
        count
      } = _ref3;
      return count;
    })
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(ChartsWrapper, {
    headLine: "XP by Category",
    tagLine: "% of Total Experience",
    tooltipText: "Shows the % of Experience Points in each of the 6 Experience Categories.",
    shouldShowTooltip: !isViewPortSmall,
    chartBackgroundColor: "yellow",
    chartPadding: isViewPortSmall ? 'medium' : 'large'
  }, /*#__PURE__*/React.createElement(DoughnutChart, {
    "data-test-id": "doughnut-chart",
    label: "Xp by category",
    displayLegend: false,
    labels: [],
    backgroundColor: [],
    data: []
  })))));
};
ProfileCharts_V2.propTypes = {
  profileId: PropTypes.number.isRequired
};